import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ContentType } from './Enums'
/**
* Class ShowcaseContentSitemapEntryDto
*  Запись контентного sitemap-фида; XML-рендер и маппинг slug → URL — на стороне шаблона витрины (SKUBY-CMS-MODULE-SPEC.md §7)
*/
export class ShowcaseContentSitemapEntryDto extends ActiveModel {

  /**
  * type
  * словарь значений публикуется под именем `ContentType`  *   * Тип контента; определяет отображение на витрине и правила валидации.  *   * - `Page` Страница  *   * Статическая страница («Доставка и оплата», положения)  * - `News` Новость  *   * Новость (лента с датой публикации)  * - `Article` Статья  *   * Статья блога (витрина — Phase 1)  * - `Instruction` Инструкция  *   * Инструкция (обычно с приложенными документами)  *   */
  @ActiveField(ContentType.PAGE)
  type: ContentType = ContentType.PAGE


/**
  * slug
  * Эффективный slug материала в текущем канале<br>
  */
  @ActiveField('')
  slug: string = ''


/**
  * updated
  * Дата последнего изменения материала (lastmod)<br>
  */
  @ActiveField('')
  updated: string = ''
}
